import React, { useState, useMemo } from "react";
import "./CloneCampaignModal.scss";
// Context
// Component Library
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Dropdown from "@acadia-ui/dropdown";
import Modal from "@acadia-ui/modal";

const CloneCampaignModal = ({ handleClone, selectedCampaignData, masterCampaigns }) => {
	const [targetCampaign, setTargetCampaign] = useState(null);

	const dropdownOptions = useMemo(() => {
		if (masterCampaigns?.length) {
			const options = masterCampaigns?.map(({ MasterCampaignName, MasterCampaignID }) => {
				return { label: MasterCampaignName, value: MasterCampaignID };
			});

			// Move the originating master campaign to the top of the list
			const parentCampaign = options.find((campaign) => {
				return campaign.value.toString() === selectedCampaignData.ParentUniqueIDcode;
			});
			options.splice(options.indexOf(parentCampaign), 1);
			options.unshift(parentCampaign);
			return options;
		}
		return [];
	}, [selectedCampaignData, masterCampaigns]);

	return (
		<Modal
			id="cloneCampaignModal"
			heading="Clone Campaign"
			description="The cloned campaign will inherit all original details. Select the destination for the new campaign and click the 'Clone' button to clone the activation campaign."
			actionSetProps={{
				actionsRight: (
					<>
						<Button
							display={BUTTON_DISPLAY.SECONDARY}
							onClick={() => {
								Modal.hide("cloneCampaignModal");
							}}
							data-tracking-id-alt="cancel-clone-campaign"
						>
							Cancel
						</Button>
						<Button
							onClick={() => {
								Modal.hide("cloneCampaignModal");
								handleClone(targetCampaign);
							}}
							disabled={!targetCampaign}
							data-tracking-id-alt="confirm-clone-campaign"
						>
							Clone
						</Button>
					</>
				)
			}}
			onClick={() => {}}
		>
			<Dropdown
				id="selectDestinationCampaignDropdown"
				className="clone_campaign_dropdown"
				onChange={setTargetCampaign}
				options={dropdownOptions}
				required={true}
				isSearchable={true}
			>
				Select Destination
			</Dropdown>
		</Modal>
	);
};
export default CloneCampaignModal;
